<div
  class="messaging-container"
  *ngIf="clinicMessagingLoaded$ | async; else messagingLoading"
>
  <salve-clinic-messaging
    [conversation_id]="conversationId$ | async"
    [language]="selectedLanguage$ | async"
    [clinic_token]="xSalveClinicToken$ | async"
  ></salve-clinic-messaging>
</div>
<ng-template #messagingLoading>
  <div class="messaging-loading">{{ (messagesText$ | async)?.Loading }}</div>
</ng-template>
